export default "__VITE_ASSET__Dzja$p0G__"